import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"
import _imports_0 from '@/assets/join-image.png'


const _hoisted_1 = { class: "join" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("div", { class: "title" }, "JOIN US NOW", -1)
const _hoisted_3 = /*#__PURE__*/_createElementVNode("div", { class: "caption" }, " 新規ご入会は、HOME画面下部の「HOME」アイコンをタップし、「MEMBERになる」よりご入会ください。 ", -1)
const _hoisted_4 = /*#__PURE__*/_createElementVNode("div", { class: "image" }, [
  /*#__PURE__*/_createElementVNode("img", {
    src: _imports_0,
    alt: "説明画像"
  })
], -1)
const _hoisted_5 = [
  _hoisted_2,
  _hoisted_3,
  _hoisted_4
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, _hoisted_5))
}